import { CheckCircle, ErrorOutline, PendingActions } from "@mui/icons-material";
import { Box, SxProps, Tooltip, Theme } from "@mui/material";
import { OverallOutcomeStatus } from "generated/graphql";
import { P } from "theme/typography";
import { displayCaseOutcomeStatus } from "Backend";

interface CaseOutcomeStatusProps {
  status: OverallOutcomeStatus;
  onlyStatus?: boolean;
}

const CaseOutcomeStatus = ({ status, onlyStatus = false }: CaseOutcomeStatusProps) => {
  const title = displayCaseOutcomeStatus(status);
  const colorSx: SxProps<Theme> =
    status === OverallOutcomeStatus.Valid
      ? { color: "success.main" }
      : status === OverallOutcomeStatus.Pending
        ? {
            color: "grey.900",
          }
        : {
            color: "error.main",
          };
  const icon =
    status === OverallOutcomeStatus.Valid ? (
      <CheckCircle sx={{ fontSize: 16, ...colorSx }} />
    ) : status === OverallOutcomeStatus.Pending ? (
      <PendingActions sx={{ fontSize: 16, ...colorSx }} />
    ) : (
      <ErrorOutline sx={{ fontSize: 16, ...colorSx }} />
    );

  return onlyStatus ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <P variant="sm" sx={{ ...colorSx, mr: 0.5 }}>
        {title}
      </P>
      {icon}
    </Box>
  ) : (
    <Tooltip title="Case Outcome">
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <P variant="xsSemiBold" sx={{ ...colorSx, mr: 0.5 }}>
          {title}
        </P>
        {icon}
      </Box>
    </Tooltip>
  );
};

export default CaseOutcomeStatus;
